import React from 'react'

const Loading = () => (
    <div className='is-flex is-align-items-center is-justify-content-center mt-5'>
        <button className='button is-loading is-text' />
        <p>Parsing the files</p>
    </div>
)

export default Loading
